import { B2BDealType, B2CDealType, CostDealType } from "@/app/constants";

import { PriceResult } from "../base/pricing.strategy";
import { ReactiveComponent } from "../../entities/base-component";
import { CalculationStrategy } from "../base/calculation.strategy";
import { Overheads } from "../../entities/overhead";

export class OverheadTotalCalculationStrategy extends CalculationStrategy {
    public calculate(component: Overheads): PriceResult {
        return {
            price: this.calculateComponentsPriceForType(
                component,
                CostDealType,
            ),
            priceB2C: this.calculateComponentsPriceForType(
                component,
                B2CDealType,
            ),
            priceB2B: this.calculateComponentsPriceForType(
                component,
                B2BDealType,
            ),
        };
    }

    private calculateComponentsPriceForType(
        component: ReactiveComponent,
        dealType: string,
    ) {
        const children = component?.components;

        if (!children || children.length === 0) {
            return 0;
        }

        return children.reduce((total, child) => {
            const price = child.sum.getSystemPrice(dealType).getValue();
            const formattedPrice =
                typeof price === "number" ? price : Number.parseFloat(String(price));

            return total + (formattedPrice || 0);
        }, 0);
    }
}
